export const facilityByOrganizationOptions = [
  {
    label: 'Owned',
    value: 'owned',
  },
  {
    label: 'Leased',
    value: 'leased',
  },
];
